<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@casl/vue";
import { useRoute } from "vue-router";
import FinalDebondAddEdit from "@/components/models/patient/forms/visitInstructions/FinalDebondAddEdit.vue";
import { useFinalDebondVisitInstructionById } from "@/composables/models/patient/visitInstructions/useFinalDebond.ts";

definePage({
  meta: {
    title: "generic.action.editEntity",
    titleParams: { entity: "generic.entity.finalDebondInstructions" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return (
        can($permActions.UPDATE, $permSubjects.PATIENT__FINALDEBONDVISITINSTRUCTIONSVISITRESULT) ||
        can(
          $permActions.FINAL_DEBOND_VISIT_INSTRUCTIONS_VISIT_RESULT,
          $permSubjects.PATIENT__FINALDEBONDVISITINSTRUCTIONSVISITRESULT
        )
      );
    },
  },
});

const route = useRoute();
const routeParams = route.params as { id: string };

const { data: instructions, isLoading } = useFinalDebondVisitInstructionById({
  id: routeParams.id,
});
</script>

<template>
  <v-skeleton-loader :loading="isLoading">
    <final-debond-add-edit :final-debond-visit-instructions="instructions" />
  </v-skeleton-loader>
</template>

<style scoped></style>
